<template>
  <div
    class="audio-player audio-player--mobile height-all"
    ref="refAudioBox"
    :style="renderStyle"
  >
    <slot>
      <div
        class="audio-player-opbox height-all flex-column"
        :class="`render-disabled--${
          props.disabled
        } render-disabled-extend--${!props.opClickCallBack}`"
      >
        <div
          class="audio-player-title audio-player-title-top olh tl"
          v-if="props.title && props.titlePosition == 'topLeft'"
        >
          {{ props.title }}
        </div>
        <div class="audio-player flex1">
          <div class="playArea flex">
            <div
              class="audio-player-op-switch audio-player-op-switch-prev pointer flex-center"
              v-if="props.switch"
              @click="
                () => {
                  doSwitch('prev');
                }
              "
            >
              <i></i>
            </div>
            <div
              class="audio-player-op boder btn"
              @click="
                () => {
                  changeOp();
                }
              "
            >
              <LoaderCircle
                :loading="renderData.isLoading"
                :size="renderData.loaderSize"
                :color="renderStyle['--opLoadingColor']"
                :marginSize="0"
                :strokeWidth="2"
                loadingColor="rgb(148, 173, 255)"
              >
                <div class="playBtn apo pointer" v-show="!renderData.isPlaying">
                  <i
                    class="block icon-play"
                    :style="{
                      background: `url(${
                        props.theme == 'dark' ? playIcoDark : playIcoLight
                      })`,
                      backgroundSize: 'cover',
                    }"
                  >
                  </i>
                </div>
                <div class="apo pointer" v-show="renderData.isPlaying">
                  <i
                    class="block icon-pause"
                    :style="{
                      background: `url(${
                        props.theme == 'dark' ? pauseIcoDark : pauseIcoLight
                      })`,
                      backgroundSize: 'cover',
                    }"
                  >
                  </i>
                </div>
                <!-- <div class="apo pointer" v-show="renderData.isPlaying&&renderData.isLoading">
                  <i class="block icon-loading rotate-loading">
                  </i>
                </div> -->
              </LoaderCircle>
            </div>
            <div
              class="audio-player-op-switch audio-player-op-switch-next pointer flex-center"
              v-if="props.switch"
              @click="
                () => {
                  doSwitch('next');
                }
              "
            >
              <i></i>
            </div>
          </div>
          <div class="progress">
            <div class="audio-player-center flex1">
              <div
                class="audio-player-title olh tl"
                v-if="props.title && props.titlePosition == 'centerTopLeft'"
              >
                {{ props.title }}
              </div>
              <div
                class="audio-player-slider"
                :class="{
                  loading: renderData.isLoading,
                }"
                :style="{
                  '--highPointerColor':
                    props.highPosition === null ||
                    props.highPosition == undefined ||
                    props.highPosition > renderData.duration
                      ? 'none'
                      : renderStyle['--progressbarColor'],
                  '--highPointerLeft': getHighPositionPosition(),
                }"
                data-scrollbox
              >
                <vue-slider
                  v-model="renderData.progress"
                  @change="changeProgress"
                  @drag-start="dragStart"
                  @drag-end="dragEnd"
                  @dragging="dragging"
                  tooltip="none"
                  :tooltipFormatter="formatTooltip"
                  :renderStyle="{
                    '--slider-height': '16px',
  
                    '--track-height': '2px',
                    '--track-radius': '1px',
                    '--track-bg-color': 'rgba(255, 255, 255, 0.2)',

                    '--progress-bg-color': '#fff',
                    '--dot-padding': '4px',

                    '--slider-dot-size': '10px',
                    '--dot-bg-color': '#fff',
                    '--dot-hover-scale': '1.2',
                  }"
                  :disableChangeProgress="props.disabled"
                  :min="0"
                  :max="100"
                  :step="0.1"
                  :barHeight="renderStyle['--barHeight']"
                  :barColor="renderStyle['--barColor']"
                  :progressBarColor="renderStyle['--progressbarColor']"
                  :progressSliderSize="renderStyle['--progressSliderSize']"
                  :progressSliderColor="renderStyle['--progressSliderColor']"
                  :progressSliderHoverColor="renderStyle['--progressSliderHoverColor']" 
                ></vue-slider>
                <div
                  v-if="props.highPosition != null"
                  class="audio-player-slider-highlight-pointer"
                  :style="{}"
                ></div>
              </div>
            </div>
            <div class="audio-player-time">
              <span>{{ renderData.startTime }}</span>
              <i
                class="block icon-loading rotate-loading"
                v-if="renderData.isGenerating"
              ></i>
              <span v-else>{{
                renderData.endTime ?? renderData.duration / 1000
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </slot>
  </div>
</template>
<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  watch,
  defineExpose,
  onMounted,
  onUnmounted,
  reactive,
  getCurrentInstance
} from "vue";
import GlobalAudioPlayer, {
  defaultPersonalizedConfig,
  lastPerContinuousPlaybackTimeData,
} from "@/components/media/audioPlayer/GlobalAudioPlayer.js";
import playIcoDark from "@/assets/img/play-ico.png";
import playIcoLight from "@/assets/img/play-light-ico.png";
import pauseIcoDark from "@/assets/img/pause-ico.png";
import pauseIcoLight from "@/assets/img/pause-light-ico.png";
import Bubble from "@/components/bubble/bubble.vue";

import VueSlider from "@/components/basic/vueSlider/VueSlider.vue";

import mediaUtil from "../utils/utils.js";

const appContext = getCurrentInstance()?.appContext;

const props = defineProps({
  renderStyle: Object,
  theme: {
    type: String,
    default: "dark", // light
  },
  titlePosition: {
    type: String,
    default: "topLeft", // centerTopLeft
  },
  title: String,

  volumeOffset: {
    type: Number,
    default: defaultPersonalizedConfig.volumeOffset,
  },
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },

  from: {
    type: Number,
    default: 0,
  },
  to: {
    type: Number,
    default: 0,
  },
  loop: {
    type: Boolean,
    default: defaultPersonalizedConfig.loop,
  },
  autoToStartIfNotCurrent: {
    type: Boolean,
    default: defaultPersonalizedConfig.autoToStartIfNotCurrent,
  },
  canSeekNotCurrent: {
    type: Boolean,
    default: defaultPersonalizedConfig.canSeekNotCurrent,
  },

  disabled: {
    type: Boolean,
    default: false,
  },
  opClickCallBack: {
    type: Function,
    default: null,
  },
  analyser: Boolean,
  switch: {
    type: Boolean,
    default: false,
  },
  highPosition: {
    type: Number,
    default: null,
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
  perContinuousPlaybackTimeCallback: {
    type: Function,
    default: () => {},
  },
  type: {
    type: String,
    default: "audio",
  },
});
const renderDefaultStyleMap = {
  dark: {
    "--opLoadingColor": "#000",
    "--opSize": "36px",
    "--opIcoSize": "20px",
    "--opBgColor": "transparent",
    "--opBgHover": "rgba(0,0,0,0.1)",
    "--opMargin": "0",

    "--opSwitchSize": "36px",
    "--opSwitchIcoSize": "20px",
    "--opSwitchBgHover": "rgba(0,0,0,0.1)",

    "--titleColor": "#000",
    "--titleFontSize": "14px",
    "--titleFontWeight": "500",

    "--timeColor": "#000",
    "--timeFontSize": "12px",
    "--timeFontWeight": "400",
    "--timeMinWidth": "38px",

    "--seekbarMargin": "0px 20px 0 10px",
    "--barColor": "rgba(0, 0, 0,  0.2)",
    "--barHeight": "2px",

    "--progressbarColor": "#000",
    "--progressSliderSize": "10px",
    "--progressSliderColor": "#000",
    "--progressSliderHoverColor": "rgba(0,0,0, 0.3)",
  },
  light: {
    "--opLoadingColor": "#fff",
    "--opSize": "36px",
    "--opBgColor": "transparent",
    "--opIcoSize": "20px",
    "--opBgHover": "rgba(0,0,0,0.1)",
    "--opMargin": "0 14px",

    "--opSwitchSize": "38px",
    "--opSwitchIcoSize": "20px",
    "--opSwitchBgHover": "rgba(0,0,0,0.1)",

    "--titleColor": "#fff",
    "--titleFontSize": "14px",
    "--titleFontWeight": "500",

    "--timeColor": "#fff",
    "--timeFontSize": "12px",
    "--timeFontWeight": "400",
    "--timeMinWidth": "36px",

    "--barColor": "rgba(255, 255, 255,  0.2)",
    "--barHeight": "2px",

    "--seekbarMargin": "0px 10px 0 10px",
    "--progressbarColor": "#fff",
    "--progressSliderSize": "10px",
    "--progressSliderColor": "#fff",
    "--progressSliderHoverColor": "rgba(255, 255, 255, 0.3)",
  },
};
const renderStyle = Object.assign(
  {},
  renderDefaultStyleMap[props.theme] || renderDefaultStyleMap["dark"],
  props.renderStyle ?? {}
);

const emits = defineEmits([
  "log",
  "drawEqualizer",
  "syncDuration",
  "syncPlayState",
  "syncLoadingState",
  "syncProgress",
  "switch",
  "play",
  "curPlayEnded",
  "update:isGenerating",
]);
const isReady = ref(false); // 是否加载完成，可以开始播放
const isChangeProgress = ref(false);

const refAudioBox = ref(null);

const getLoadingSize = () => {
  return Number(renderStyle["--opSize"].replace("px", "")) - 2;
};
const stateData = {};

const renderData = reactive({
  url: props.url,
  currentTime: 0,
  startTime: "00:00",
  endTime: "00:00",
  bufferTime: "00:00",
  duration: props.duration,
  progress: 0,
  isPlaying: false,
  isLoading: false,
  isReady: false,
  loaderSize: getLoadingSize(),
  isGenerating: false,
});
const getHighPositionPosition = () => {
  return (props.highPosition ?? 0) > (renderData.duration || 1)
    ? 100
    : ((props.highPosition ?? 0) / (renderData.duration || 1)) * 100 + "%";
};
const formatTooltip = () => {
  return mediaUtil.formatProgressToTime(
    renderData.progress,
    renderData.duration
  );
};

const analyzeStateData = {
  startPosition: 0,
};

// play or pause
const changeOp = (isplay) => {
  if (props.opClickCallBack) {
    props.opClickCallBack();
  }
  if (props.disabled) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(renderData.url, true);
    return;
  }
  const isPlaying =
    typeof isplay === "boolean" ? isplay : !renderData.isPlaying;
  if (isPlaying) {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.play(renderData.url, true);
    emits("play", renderData.url);
  } else {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(renderData.url);
  }
};

const doSwitch = (data) => {
  changeOp(false);
  emits("switch", data);
};

// var playStateBeforeSeek = undefined;
const emitsPerContinuousPlaybackTimeCallback = (opType) => {
  if (
    lastPerContinuousPlaybackTimeData.url == renderData.url &&
    lastPerContinuousPlaybackTimeData.startPosition ==
      analyzeStateData.startPosition &&
    lastPerContinuousPlaybackTimeData.time ==
      renderData.progressCp * renderData.duration -
        analyzeStateData.startPosition
  ) {
    return;
  }
  if (
    renderData.progressCp * renderData.duration -
      analyzeStateData.startPosition >
    0
  ) {
    const data = {
      duration: renderData.duration,
      url: renderData.url,
      startPosition: analyzeStateData.startPosition,
      time:
        renderData.progressCp * renderData.duration -
        analyzeStateData.startPosition,
      endPosition: renderData.progressCp * renderData.duration,
      opType: opType
    };

    // console.log(
    //   "emitsPerContinuousPlaybackTimeCallback",
    //   data,
    //   lastPerContinuousPlaybackTimeData
    // );
    props.perContinuousPlaybackTimeCallback?.(data);
    Object.assign(lastPerContinuousPlaybackTimeData, data);
  }
};

const changeProgress = (value) => {
  stateData.isChangeProgress = false;
  
  emitsPerContinuousPlaybackTimeCallback('changeProgress');

  renderData.progress = Math.min(100, Math.max(0, value));
  renderData.progressCp = renderData.progress / 100;
  renderData.startTime = mediaUtil.formatProgressToTime(
    value,
    renderData.duration
  );
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.seek(renderData.url, renderData.progress / 100);
  touchEnd();

  analyzeStateData.startPosition = renderData.duration * renderData.progressCp;
};

const dragStart = () => {
  stateData.isChangeProgress = true;
};

const dragEnd = () => {
  stateData.isChangeProgress = false;
};

const dragging = (value) => {
  renderData.progress = Math.min(100, Math.max(0, value));
  renderData.startTime = mediaUtil.formatProgressToTime(
    value,
    renderData.duration
  );
};

const init = () => {
  if (!renderData.url) {
    return;
  }
  stateData.curPlayerData = appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registerPlayUrl(renderData.url, {
    duration: props.duration ?? 0,
    clipStart: props.from,
    clipEnd: props.to,
    personalizedConfig: {
      loop: props.loop,
      autoToStartIfNotCurrent: props.autoToStartIfNotCurrent,
      canSeekNotCurrent: props.canSeekNotCurrent,
    },
    listeners: {
      onDurationChange({
        duration,
        durationTime,
        sourceDuration,
        sourceDurationTime,
      }) {
        if (renderData.url == stateData.curPlayerData?.player?.url) {
          renderData.duration = duration;
          renderData.endTime = durationTime;
          if (
            renderData.isGenerating &&
            appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.audio?.duration == duration &&
            duration > 0 &&
            renderData.url == appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl
          ) {
            renderData.isGenerating = false;
          }
        }
      },
      onPlayStateChange(isPlaying, eventType) {
        if (renderData.url == stateData.curPlayerData?.player?.url) {
          renderData.isPlaying = isPlaying;
          if (isPlaying) {
            analyzeStateData.startPosition =
              renderData.progressCp * renderData.duration;
          } else {
            emitsPerContinuousPlaybackTimeCallback('palyStateChange');
            analyzeStateData.startPosition =
              renderData.progressCp * renderData.duration;
          }
        }
      },
      onLoadingStateChange(isLoading) {
        if (renderData.url == stateData.curPlayerData?.player?.url) {
          renderData.isLoading = isLoading;
        }
      },
      onPositionChange: (obj) => {
        if (renderData.url == stateData.curPlayerData?.player?.url) {
          const { progress, currentTime, endTime, current } = obj;
          if (!stateData.isChangeProgress) {
            renderData.startTime = currentTime;
            renderData.endTime = endTime;
            renderData.progress = Math.min(100, Math.max(0, progress * 100));
            renderData.currentTime = current;
          }
          renderData.progressCp = progress;
        }
      },
    },
  });
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registGlobalListener(
    "curPlayEnded",
    ({ currentUrl, player }) => {
      if (renderData.url == currentUrl || !renderData.url) {
        emits("curPlayEnded", { currentUrl, player });
        emitsPerContinuousPlaybackTimeCallback('curPlayEnded');
        analyzeStateData.startPosition = 0;
      }
    }
  );
  if (
    stateData.curPlayerData?.player &&
    stateData.curPlayerData?.player?.url == appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl
  ) {
    renderData.isPlaying = stateData.curPlayerData?.player?.isPlaying;
    const { progress, currentTime, endTime } =
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.getPositionData(stateData.curPlayerData?.player);
    const { duration } = appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.getDuration(
      stateData.curPlayerData?.player
    );
    renderData.duration = duration;
    renderData.progress = Math.min(100, Math.max(0, progress * 100));
    renderData.progressCp = progress;
    renderData.startTime = currentTime;
    renderData.endTime = endTime;
    emits("syncPlayState", renderData.isPlaying);
    emits("syncProgress", renderData.progress, renderData.startTime);
    emits("syncDuration", renderData.duration);
  }
  // console.log("init🍎苹果", stateData.curPlayerData);
};

const handleTouchStart = () => {};

const touchEnd = () => {
  // if (jsBridge.inTiangongApp) {
  //   jsBridge("event.requestGesture", { eventTye: "horizontal", action: "release" })
  // }
};

watch(
  () => renderData.isPlaying,
  (newValue) => {
    emits("syncPlayState", renderData.isPlaying);
  }
);
watch(
  () => renderData.isLoading,
  (newValue) => {
    emits("syncLoadingState", renderData.isLoading);
  }
);
watch(
  () => renderData.progress,
  (newValue) => {
    emits(
      "syncProgress",
      renderData.progress,
      renderData.startTime,
      renderData.currentTime
    );
  }
);

watch(
  () => props.disabled,
  (newValue) => {
    if (props.disabled) {
      console.log("props.disabled", props.disabled);
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.pause(renderData.url, true);
    }
  }
);

watch(
  () => {
    return props.duration;
  },
  () => {
    if (
      renderData.url == appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl &&
      renderData.duration != props.duration
    ) {
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.setDuration(renderData.url, props.duration);
    }
    renderData.duration = props.duration;
    renderData.endTime = mediaUtil.formatTime(props.duration);
  }
);

watch(
  () => {
    return props.url;
  },
  () => {
    if (props.url != renderData.url) {
      if (stateData.curPlayerData) {
        appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData);
      }
      renderData.url = props.url;
      init();
    }
  }
);

watch(
  () => {
    return props.loop;
  },
  () => {
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.setLoop(renderData.url, props.loop);
  }
);

watch(
  () => {
    return props.isGenerating;
  },
  (newValue) => {
    renderData.isGenerating = newValue;
  }
);

watch(
  () => {
    return renderData.isGenerating;
  },
  (newValue) => {
    emits("update:isGenerating", newValue);
  }
);

onMounted(() => {
  renderData.url = props.url;
  renderData.duration = props.duration;
  renderData.endTime = mediaUtil.formatTime(props.duration);
  renderData.loaderSize = getLoadingSize();
  renderData.isGenerating = props.isGenerating;

  init();
  stateData.playerCacheData = {
    uuid: appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.getUuid(),
    pause() {
      changeOp(false);
    },
    getContainer() {
      return refAudioBox.value;
    },
  };
});

onUnmounted(() => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData);
});

defineExpose({
  changeOp,
  changeProgress,
  triggleEmitsPerContinuousPlaybackTimeCallback(opType) {
    emitsPerContinuousPlaybackTimeCallback(opType);
  },
  init(){
    const appContext = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))?.appContext;
    if (stateData.curPlayerData) {
      appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releasePlayer(stateData.curPlayerData);
    }
    renderData.url = props.url;
    renderData.duration = props.duration;
    renderData.endTime = mediaUtil.formatTime(props.duration);
    console.log("🍎renderData.url🍎", renderData.url);
    init();
  }
});
</script>
<style lang="scss">
.audio-player.audio-player--mobile {
  .playArea {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  .audio-player-opbox {
  }
  .audio-player {
    align-items: center;
  }
  .audio-player-op {
    height: var(--opSize);
    width: var(--opSize);
    min-width: var(--opSize);
    border-radius: var(--opSize);
    margin: var(--opMargin);

    display: flex;
    align-items: center;
    justify-content: center;
    &.boder {
      border: 2px solid #fff;
    }
  }
  /*.audio-player-op:hover {
    background-color: var(--opHoverBg);
  }*/
  .apo.pointer {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--opSize);
    background: var(--opBgColor);
  }
  i.block {
    width: var(--opIcoSize);
    height: var(--opIcoSize);
  }
  i.icon-loading.block {
    width: calc(var(--opIcoSize) - 6px);
    height: calc(var(--opIcoSize) - 6px);
  }
  /*.apo.pointer:hover{
    background: var(--opBgHover);
  }*/

  .audio-player-op.play {
    background: url(../../../assets/img/player/play.svg);
    background-size: 100% 100%;
  }
  .audio-player-op.stop {
    background: url(../../../assets/img/pause-ico.png);
    background-size: 100% 100%;
  }
  .audio-player-op.ratate-loading {
    height: 20px;
    width: 20px;
  }

  .audio-player-op-switch {
    height: var(--opSwitchSize);
    width: var(--opSwitchSize);
    min-width: var(--opSwitchSize);
    border-radius: var(--opSwitchIcoSize);
    margin-right: 0;
    i {
      width: var(--opSwitchIcoSize);
      height: var(--opSwitchIcoSize);
    }
    &:hover {
      background-color: var(--opSwitchHoverBg);
    }
    &.audio-player-op-switch-prev {
      i {
        background: url(../../../assets/img/switch-prev-ico.png);
        background-size: 100% 100%;
      }
    }
    &.audio-player-op-switch-next {
      margin-right: 8px;
      i {
        background: url(../../../assets/img/switch-next-ico.png);
        background-size: 100% 100%;
      }
    }
  }
  .audio-player-title {
    font-size: var(--titleFontSize);
    font-weight: var(--titleFontWeight);
    color: var(--titleColor);
    line-height: var(--titleFontSize);
    padding: 0 0 5px 0;
    max-width: 100%;
  }
  .audio-player-title-top {
    padding: 0 0 1px 6px;
  }
  .audio-player-time {
    display: flex;
    justify-content: space-between;
    font-family: Source Han Sans;
    margin-top: 2px;
    font-size: var(--timeFontSize);
    font-weight: var(--timeFontWeight);
    color: var(--timeColor);
    min-width: var(--timeMinWidth);
    line-height: calc(var(--timeFontSize) * 1.5);
    letter-spacing: 0.075em;
    i.icon-loading.block {
      width: calc(var(--timeFontSize) * 1.25);
      height: calc(var(--timeFontSize) * 1.25);
      background: url(@/assets/img/loading.png);
      background-size: 100% 100%;
    }
  }
  .audio-player-center {
    margin-left: 4px;
    margin: var(--seekbarMargin);
  }
  .audio-player-slider {
    position: relative;
    .vue-slider {
      height: var(--barHeight) !important;
      .vue-slider-rail {
        height: var(--barHeight);
        width: 100%;
        border-radius: 4px 4px 4px 4px;
        box-sizing: content-box;
        background-color: var(--barColor);
        &:after {
          content: "";
          position: absolute;
          height: 4px;
          width: 4px;
          border-radius: 4px;
          top: -1px;
          left: var(--highPointerLeft);
          background: var(--highPointerColor);
        }
      }

      .vue-slider-process {
        height: var(--barHeight);
        border-radius: 4px 4px 4px 4px;
        background: var(--progressbarColor);
      }
      .vue-slider-dot {
        width: 24px !important;
        height: 24px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        .vue-slider-dot-handle {
          width: var(--progressSliderSize);
          height: var(--progressSliderSize);
          background: var(--progressSliderColor);
        }
        &:hover {
          .vue-slider-dot-handle {
            transform: scale(1.2);
          }
        }
      }
    }
  }

  .render-disabled--true {
    opacity: 0.5;
    .audio-player-op {
      cursor: not-allowed;
    }
    .audio-player-op:hover {
      background-color: transparent;

      .apo.pointer:hover {
        cursor: not-allowed;
        background: transparent;
      }
    }
  }
  .render-disabled-extend--false {
    opacity: 1;
    .audio-player-op {
      cursor: unset;
      opacity: 0.8;
    }
    .audio-player-center {
      cursor: not-allowed;
      opacity: 0.5;
    }
    .audio-player-time {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
}
</style>
